import React from 'react';
import config from '../config';

const Navbar = () => {
  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-gray-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-3 md:py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center gap-2 md:gap-3 cursor-pointer" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
            <div className="flex items-center justify-center w-9 h-9 md:w-10 md:h-10 bg-sky-100 rounded-lg">
              <svg className="w-5 h-5 md:w-6 md:h-6 text-sky-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="width"
                  strokeWidth={2}
                  d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                />
              </svg>
            </div>
            <div className="hidden sm:block">
              <div className="text-gray-900 font-bold text-base md:text-lg leading-tight">Driver Medical Exam</div>
              <div className="text-gray-500 text-xs">South Vancouver Medical</div>
            </div>
            <div className="sm:hidden">
              <div className="text-gray-900 font-bold text-sm leading-tight">Driver Medical</div>
            </div>
          </div>

          {/* Contact & CTA */}
          <div className="flex items-center gap-2 md:gap-4">
            <a href="mailto:info@southvanmed.com" className="hidden md:flex items-center gap-2 text-gray-700 hover:text-sky-600 transition-colors">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="width" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              <span className="font-semibold">info@southvanmed.com</span>
            </a>

            <a
              href={config.southVanLogin}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-sky-600 hover:bg-sky-700 text-white font-semibold text-sm md:text-base px-4 md:px-6 py-2 md:py-3 rounded-lg transition-all duration-200 shadow-sm hover:shadow-md touch-manipulation"
            >
              Book Now
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
};

export { Navbar };
